import {texture} from "p3";
import definitions from "../../../definitions";
import NPC from "./NPC";

export default class NPCNobleSwan1 extends NPC {
    constructor() {
        super(definitions.NPC_ID.NOBLESWAN_1);

        this.collisionRadius = 26;
        this.collisionOffsetX = -1;
        this.collisionOffsetY = -26;
    }

    init() {
        super.init();

        this.addViewWithTexture(texture("char_nobleswan_1_idle_00"));

        this.addShadow(definitions.SHADOW_SIZE.LARGE, 0.6, new PIXI.Point(0, -6));
        this.animateIdle(0.6);
    }
}